import { render, staticRenderFns } from "./DepartmentsConfigurationModal.vue?vue&type=template&id=051245f8&"
import script from "./DepartmentsConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./DepartmentsConfigurationModal.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentsConfigurationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports